/****************************************************************
 * shared variables, constants and type definitions
 ***************************************************************/

export enum SastTab {
  AccountsList = 'accounts-list',
  RepositoriesList = 'repository-list',
}

export enum RepositoryStatus {
  Connected = 'Connected',
  // Repository initially connected with our platform

  Scheduled = 'Scheduled',
  // Repository is scheduled for scanning

  ScanInitiated = 'Scan Initiated',
  // Starting the Scan

  Scanning = 'Scanning',
  // Scanning in progress

  ScanCompleted = 'Scan Completed',
  // Scan completed

  AwaitingSync = 'Awaiting Sync',
  // REGULAR SCAN: Scan completed, waiting to sync with sonar server

  AnalyzingResults = 'Analyzing Results',
  // MANUAL SCAN: Analyzing results

  Syncing = 'Syncing',
  // Syncing results with platform

  PartiallyScanned = 'Partially Scanned',
  // Repository is partially scanned

  SyncCompleted = 'Sync Completed',
  // Syncing completed

  Error = 'Scan Error',
  // Error or failure occurred

  TimeoutDelay = 'Timeout/Delay',
  // Timeout or delay in process

  Deactivated = 'Deactivated',
  // Repository deactivated from scanning

  Disconnected = 'Disconnected',
  // Lost the connection or access information

  Unknown = 'Unknown',
  // Unknown status
}
